import { createReducer, createActions } from 'reduxsauce';
import moment from 'moment';

export const PROPERTY_STEPS = {
  BASIC_INFO: 0,
  MORE_INFO: 1,
  PRICING: 2
};

const { Types, Creators } = createActions({
  setPropertyStep: ['step'],
  resetProperty: ['property'],
  setPropertyLoading: ['loading'],
  loadPropertyRequest: ['propertyId'],
  updateLocalProperty: ['apiProperty', 'currentData'],
  setPropertyId: ['propertyId'],
  setPropertyBasicInfo: ['basicInfo'],
  setPropertyMoreInfo: ['moreInfo'],
  setPropertySettings: ['propertySettings'],
  addNewPropertySetting: ['setting'],
  setCurrentPropertySetting: ['setting'],
  updateCurrentPropertySetting: ['values'],
  setGlobalPropertySettings: ['globalSettings']
});

export const PropertyTypes = Types;
export default Creators;

/* ------- Initial State --------- */

const PROPERTY_ONLY_STATE = {
  loading: false,
  currentStep: PROPERTY_STEPS.BASIC_INFO,
  propertyId: '',
  basicInfo: {
    name: '',
    address: '',
    city: '',
    state: '',
    zipcode: '',
    isBuildingRequired: false,
    buildingsNames: ['', ''],
    bedroomsCounts: [],
    unitsCount: ''
  },
  moreInfo: {
    status: 'active',
    activeAt: moment(),
    keyRelease: '',
    office: undefined,
    region: null,
    keyReleaseEmail: [''],
    firstDayOfService: null,
    serviceAvailability: []
  },
  currentPropertySetting: {},
  propertySettings: []
};
export const INITIAL_STATE = {
  globalSettings: [],
  ...PROPERTY_ONLY_STATE
};

/* ------- Selectors --------- */
export const PropertySelectors = {
  selectPropertyId: state => state.property.propertyId,
  selectAllGlobalSettings: state => state.property.globalSettings,
  selectAllSettings: state => state.property.propertySettings,
  selectIsLoading: state => state.property.loading,
  selectCurrentStep: state => state.property.currentStep,
  selectBasicInfo: state => state.property.basicInfo,
  selectMoreInfo: state => state.property.moreInfo,
  selectActiveGlobalSetting: state =>
    (state.property.globalSettings || []).find(item => !!item.isActive),
  selectActiveSetting: state => {
    const activeSetting = (state.property.propertySettings || []).find(
      item => !!item.isActive
    );
    if (activeSetting) {
      return activeSetting;
    }

    return PropertySelectors.selectActiveGlobalSetting(state);
  },
  selectCurrentPriceSetting: state => state.property.currentPropertySetting
};

/* -------- Reducers ---------- */

export const resetProperty = (state, { property }) => {
  return {
    ...state,
    ...PROPERTY_ONLY_STATE,
    ...property
  };
};

export const setPropertyStep = (state, { step }) => {
  return {
    ...state,
    currentStep: step
  };
};

export const setPropertyBasicInfo = (state, { basicInfo }) => {
  return {
    ...state,
    basicInfo: { ...basicInfo }
  };
};

export const setPropertyMoreInfo = (state, { moreInfo }) => {
  return {
    ...state,
    moreInfo: { ...moreInfo }
  };
};

export const setPropertyLoading = (state, { loading }) => {
  return {
    ...state,
    loading
  };
};

export const setPropertyId = (state, { propertyId }) => {
  return {
    ...state,
    propertyId
  };
};

export const setPropertySettings = (state, { propertySettings }) => {
  return {
    ...state,
    propertySettings
  };
};

export const setGlobalPropertySettings = (state, { globalSettings }) => ({
  ...state,
  globalSettings
});

export const addNewPropertySettings = (state, { setting }) => {
  const inactiveSettings = state.propertySettings.map(setting => ({
    ...setting,
    isActive: false
  }));
  return {
    ...state,
    propertySettings: inactiveSettings.concat(setting)
  };
};

export const setCurrentPropertySetting = (state, { setting }) => {
  return {
    ...state,
    currentPropertySetting: { ...setting }
  };
};

export const updateCurrentPropertySetting = (state, { values }) => {
  return {
    ...state,
    currentPropertySetting: { ...state.currentPropertySetting, ...values }
  };
};

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.RESET_PROPERTY]: resetProperty,
  [Types.SET_PROPERTY_LOADING]: setPropertyLoading,
  [Types.SET_PROPERTY_STEP]: setPropertyStep,
  [Types.SET_PROPERTY_ID]: setPropertyId,
  [Types.SET_PROPERTY_BASIC_INFO]: setPropertyBasicInfo,
  [Types.SET_PROPERTY_MORE_INFO]: setPropertyMoreInfo,
  [Types.SET_PROPERTY_SETTINGS]: setPropertySettings,
  [Types.SET_GLOBAL_PROPERTY_SETTINGS]: setGlobalPropertySettings,
  [Types.ADD_NEW_PROPERTY_SETTING]: addNewPropertySettings,
  [Types.SET_CURRENT_PROPERTY_SETTING]: setCurrentPropertySetting,
  [Types.UPDATE_CURRENT_PROPERTY_SETTING]: updateCurrentPropertySetting
});
